<template>
  <a-modal
    :title="form.id ? '编辑资产卡片' : '手工登记资产卡片'"
    :width="800"
    :visible="visible"
    :confirmLoading="saving"
    :maskClosable="false"
    style="top: 30px;"
    @ok="handleSave"
    @cancel="close">
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="资产名称" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input v-decorator="['assetName', { rules: [{ required: true, message: '请输入资产名称' }] }]" placeholder="请输入资产名称" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="规格型号" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input v-decorator="['assetModel']" placeholder="请输入规格型号" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="资产类别" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-tree-select
              v-decorator="['categoryId', { rules: [{ required: true, message: '请选择资产类别' }] }]"
              :dropdownStyle="{ maxHeight: '260px', overflow: 'auto' }"
              :treeData="categoryTree"
              allow-clear
              treeDefaultExpandAll
              placeholder="选择类别（带出政策/费用科目/税法年限）"
              @change="onCategoryChange" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="折旧政策" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-select v-decorator="['policyId']" placeholder="选择折旧政策（默认取类别政策）" allow-clear>
              <a-select-option v-for="p in policyOptions" :key="p.id" :value="p.id">{{ p.policyName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="资产原值" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input-number v-decorator="['originalValue', { rules: [{ required: true, message: '请输入资产原值' }] }]" style="width: 100%" :min="0" :precision="2" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="残值率(%)" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input-number v-decorator="['residualRatePercent']" style="width: 100%" :min="0" :max="100" :precision="2" placeholder="默认5" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="使用年限(月)" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input-number v-decorator="['serviceLife']" style="width: 100%" :min="0" :precision="0" placeholder="默认取政策年限" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="启用日期" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-date-picker v-decorator="['startDate']" style="width: 100%" format="YYYY-MM-DD" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="管理部门ID" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input-number v-decorator="['departmentId']" style="width: 100%" :precision="0" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="存放地点" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input v-decorator="['location']" placeholder="请输入存放地点" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="保管人" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input v-decorator="['responsiblePerson']" placeholder="请输入保管人" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="折旧费用科目编码" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input v-decorator="['depExpenseCode']" placeholder="默认取类别/政策配置" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="税法年限(月)" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input-number v-decorator="['taxLifeMonths']" style="width: 100%" :min="0" :precision="0" placeholder="默认取类别税法年限" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="一次性税前扣除" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-radio-group v-decorator="['taxOneOff', { initialValue: '0' }]">
              <a-radio value="0">否</a-radio>
              <a-radio value="1">是</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item label="预计总工作量" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input-number v-decorator="['totalWorkload']" style="width: 100%" :min="0" placeholder="工作量法填写" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="工作量单位" :labelCol="{ span: 8 }" :wrapperCol="{ span: 14 }">
            <a-input v-decorator="['workloadUnit']" placeholder="如 小时/公里" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="备注" :labelCol="{ span: 4 }" :wrapperCol="{ span: 19 }">
            <a-textarea v-decorator="['remark']" :rows="2" placeholder="请输入备注" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import { assetSave, categoryList, policyList } from './api/fixedAsset'
import moment from 'moment'

export default {
  name: 'AssetCardModal',
  data() {
    return {
      visible: false,
      saving: false,
      editId: null,
      form: this.$form.createForm(this),
      categoryTree: [],
      categoryMap: {},
      policyOptions: []
    }
  },
  methods: {
    /** 打开：record 为空=登记，否则编辑 */
    open(record) {
      this.visible = true
      this.loadCategories()
      this.loadPolicies()
      this.$nextTick(() => {
        this.form.resetFields()
        if (record && record.id) {
          this.editId = record.id
          const rate = record.residualRate == null ? null : Number(record.residualRate) * 100
          this.form.setFieldsValue({
            assetName: record.assetName,
            assetModel: record.assetModel,
            categoryId: record.categoryId,
            policyId: record.policyId,
            originalValue: record.originalValue == null ? undefined : Number(record.originalValue),
            residualRatePercent: rate,
            serviceLife: record.serviceLife == null ? undefined : Number(record.serviceLife),
            startDate: record.startDate ? moment(record.startDate, 'YYYY-MM-DD') : null,
            departmentId: record.departmentId == null ? undefined : Number(record.departmentId),
            location: record.location,
            responsiblePerson: record.responsiblePerson,
            depExpenseCode: record.depExpenseCode,
            taxLifeMonths: record.taxLifeMonths == null ? undefined : Number(record.taxLifeMonths),
            taxOneOff: record.taxOneOff || '0',
            totalWorkload: record.totalWorkload == null ? undefined : Number(record.totalWorkload),
            workloadUnit: record.workloadUnit,
            remark: record.remark
          })
        }
      })
    },
    close() {
      this.visible = false
    },
    loadCategories() {
      categoryList().then((res) => {
        if (res && res.success) {
          const rows = res.data || []
          this.categoryMap = {}
          rows.forEach((r) => { this.categoryMap[r.id] = r })
          this.categoryTree = this.buildTree(rows, null)
        }
      })
    },
    buildTree(list, parentId) {
      return list
        .filter((r) => (r.parentId == null ? null : Number(r.parentId)) === parentId)
        .map((r) => ({
          key: r.id,
          value: r.id,
          title: r.name,
          children: this.buildTree(list, r.id)
        }))
    },
    loadPolicies() {
      policyList({ page: 1, pageSize: 100 }).then((res) => {
        if (res && res.success) {
          this.policyOptions = (res.data && res.data.records) || []
        }
      })
    },
    /** 类别切换：带出默认政策/费用科目/税法年限（仅空值时填充） */
    onCategoryChange(value) {
      if (!value) return
      const cat = this.categoryMap[value]
      if (!cat) return
      const values = {}
      if (!this.form.getFieldValue('policyId') && cat.defaultPolicyId) values.policyId = cat.defaultPolicyId
      if (!this.form.getFieldValue('depExpenseCode') && cat.depExpenseCode) values.depExpenseCode = cat.depExpenseCode
      if (this.form.getFieldValue('taxLifeMonths') == null && cat.taxLifeMonths != null) values.taxLifeMonths = Number(cat.taxLifeMonths)
      if (Object.keys(values).length) this.form.setFieldsValue(values)
    },
    handleSave() {
      this.form.validateFields((err, values) => {
        if (err) return
        const payload = { ...values }
        // 残值率：百分比 → 小数
        if (payload.residualRatePercent != null) {
          payload.residualRate = Number(payload.residualRatePercent) / 100
        }
        delete payload.residualRatePercent
        // 日期序列化
        if (payload.startDate) payload.startDate = payload.startDate.format('YYYY-MM-DD')
        if (this.editId) payload.id = this.editId
        this.saving = true
        assetSave(payload).then((res) => {
          this.saving = false
          if (res && res.success) {
            this.$message.success(res.message || '保存成功')
            this.visible = false
            this.$emit('ok')
          } else {
            this.$message.error((res && res.message) || '保存失败')
          }
        }).catch(() => {
          this.saving = false
          this.$message.error('保存失败')
        })
      })
    }
  },
  watch: {
    visible(v) {
      if (!v) this.editId = null
    }
  }
}
</script>
